var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};
const constants = require('./constants');

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
  },
  {
    id: "ref_id",
    label: "機器管理番号",
    type: types.INPUT,
    import: { 
      enabled: true,
      alias:["機器管理番号\r\n(必須)"]
    },
  },
  {
    id: "fk_id",
    label: "fk_id",
    type: types.INPUT,
  },
  {
    id: "tab_id",
    label: "tab_id",
    type: types.INPUT,
  },
  {
    id: "req_seq",
    tab_size:10,
    label: "証書管理番号",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "jurisdiction_classification",
    label: "所管区分",
    type: types.SELECT_BOX,
    error_if_blank:true,
    listen_for_value: "jurisdiction_classification_force_update",
    options: ["EUC・その他","IT所管システム"],
    api_uniq_grouping:true,
    import: { enabled: true },
  },
  {
    id: "department_in_charge",
    label: "ライセンス所管部署",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api: "/master_belongs/list_department",
    default_from_local_storage:"userDepartment",
    listen_for_value: "department_in_charge_force_update",
    limit_department_on_search:true,
    limit_department_on_load:true,
    api_uniq_grouping:true,
    global_emit:"equipment_in_charge_department_selected",
    search_option:{
      define_department_limit_to_key:"responsible_team"
    },
    import: { enabled: true },
  },
  {
    id: "responsible_team",
    label: "ライセンス所管チーム",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    default_from_local_storage:"userTeam",
    api: "/master_belongs/list_team_and_department",
    listen_for_value: "responsible_team_force_update",
    api_field_name:"team",
    api_uniq_grouping:true,
    limit_department_on_search:true,
    api_filter_to_other_field:{
      by_field:"department_in_charge",
      compare_api_key:"department",
      filter_data_on_event:"equipment_in_charge_department_selected",
    },
    search_option:{
      define_department_limit_by_key:"department_in_charge",
      api_field_name:"department",
    },
    import: { enabled: true },
  },

  {
    id: "jurisdiction_system",
    label: "ライセンス所管システム",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api_uniq_grouping:true,
    listen_for_value: "jurisdiction_system_force_update",
    api:"/master_system/list_system_name",
    import: { enabled: true },
  },
  {
    id: "jurisdiction_system_name_in_use",
    label: "所管システム/用途",
    type: types.INPUT,
    listen_for_value: "jurisdiction_system_name_in_use_force_update",
    import: { enabled: true },
  },
  {
    id: "maker",
    label: "メーカ",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    listen_for_value: "maker_force_update",
    api_uniq_grouping:true,
    event_emit_bus_key:"associated_device_manufacture_name_software_name",
    api:"/master_maker/list_maker_name",
    import: { enabled: true },
  },
  {
    id: "software",
    label: "ソフトウェア名",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api_uniq_grouping:true,
    listen_for_value: "software_force_update",
    api:"/master_software/list_software_name",
    api_filter_bus_key:"associated_device_manufacture_name_software_name",
    import: { enabled: true },
  },
  {
    id: "software_jurisdiction",
    label: "ソフトウェア所管",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      constants.SOFTWARE_JURISDICTION.OWN_DEPARTMENT,constants.SOFTWARE_JURISDICTION.OTHER_DEPARTMENT,constants.SOFTWARE_JURISDICTION.PRE_INSTALL,constants.SOFTWARE_JURISDICTION.LEASING_AND_RENTAL
    ],
    default_value:constants.SOFTWARE_JURISDICTION.OWN_DEPARTMENT,
    import: { enabled: true },
  },
  {
    id: "item_number",
    label: "使用するライセンス数",
    tab_size:10,
    type: types.INPUT,
    error_if_blank:true,
    listen_for_value: "licence_item_number_force_update",
    field_type:"number",
    min_value:"1",
    import: { enabled: true,
    alias:["紐付本数\r\n(半角数字)"] },
  },
  {
    id: "virtual_id",
    label: "仮想",
    tab_size:10,
    type: types.SELECT_BOX,
    default_value:"無",
    options: ["有","無"],
    import: { enabled: true,
    alias:["仮想\r\n(有/無)"] },
  },
  {
    id: "certificate_management_number",
    label: "証書管理番号",
    type: types.INPUT,
    listen_for_value: "management_number_force_update",
    import: { 
      enabled: true,
      alias:["紐付証書管理番号"]
     },
  },
  {
    id: "certificate_software_number",
    label: "証書管理番号",
    type: types.INPUT,
    listen_for_value: "management_number_force_update",
    import: { 
      enabled: true,
      alias:["紐付証書管理番号"]
     },
  },
  {
    id: "associated_device_seq_id",
    label: "associated_device_seq_id",
    type: types.INPUT,
  },
  {
    id: "certificate_software_seq_id",
    label: "certificate_software_seq_id",
    type: types.INPUT,
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_device_embedded_detail.js